import { type JSX, type ReactNode, useState } from 'react';

import { Rueckfrage } from './Rueckfrage';

/**
 * „Entwurf löschen …“ mit Rückfrage im Pop-up (Auftrag CRM-119, L8).
 *
 * DAT-25, SYS-16: gelöscht wird logisch — der Entwurf liegt danach 30 Tage im
 * Papierkorb. Für den Anwender ist er aus der Arbeit verschwunden, deshalb
 * fragt die Maske vorher nach (Tabelle 29, ÄA-62 B). Die Regeln, WELCHER
 * Entwurf gehen darf, stehen in der API; die Maske zeigt den Knopf nur dort,
 * wo die API ihn annimmt, und nennt den Grund, wo er zu ist.
 *
 * Ein Fehler der API bleibt im Pop-up stehen: `beiLoeschen` wirft, und die
 * Rückfrage schließt erst beim Erfolg.
 */
export function EntwurfLoeschen({
  frage,
  unterzeile,
  gesperrt,
  beiLoeschen,
  children,
}: {
  readonly frage: string;
  readonly unterzeile: string;
  /** Warum der Entwurf gerade nicht gehen darf — dann ist der Knopf zu. */
  readonly gesperrt?: string | undefined;
  readonly beiLoeschen: () => Promise<void>;
  /** Was das Löschen bewirkt, in der Sprache des Belegs. */
  readonly children: ReactNode;
}): JSX.Element {
  const [offen, setzeOffen] = useState(false);
  return (
    <>
      <div className="knopfreihe">
        <button
          type="button"
          className="knopf knopf--eingriff"
          disabled={gesperrt !== undefined}
          onClick={() => setzeOffen(true)}
        >
          Entwurf löschen …
        </button>
      </div>
      {gesperrt !== undefined && <p className="feld__hilfe">{gesperrt}</p>}
      {offen && (
        <Rueckfrage
          frage={frage}
          unterzeile={unterzeile}
          tat="Löschen"
          beiSchliessen={() => setzeOffen(false)}
          beiBestaetigen={async () => {
            await beiLoeschen();
            setzeOffen(false);
          }}
        >
          {children}
        </Rueckfrage>
      )}
    </>
  );
}
